import { useAuth } from '../context/AuthContext';

const PLAN_ORDER = ['free', 'premium', 'admin'];

export function usePermissions() {
  const { user } = useAuth();
  const plan = user?.plan || 'free';
  const permissions = user?.permissions || [];

  const isAdmin = plan === 'admin';

  return {
    plan,
    permissions,
    isAdmin,
    /** Check if user has a specific feature permission — admin bypasses all checks */
    canAccess: (feature) => isAdmin || permissions.includes(feature),
    /** Check if user's plan matches any of the given plans */
    isPlan: (...plans) => plans.includes(plan),
    /** Check if user's plan is >= the minimum required plan — admin always passes */
    meetsMinPlan: (min) => isAdmin || PLAN_ORDER.indexOf(plan) >= PLAN_ORDER.indexOf(min),
  };
}
